import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-fire-extinguishers',
  templateUrl: './certificate-fire-extinguishers.component.html',
  styleUrls: ['./certificate-fire-extinguishers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateFireExtinguishersComponent extends CertificateComponent {}
